import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "stacking-drawer-content" }
const _hoisted_2 = { class: "stacking-drawer-handle" }
const _hoisted_3 = { class: "stacking-drawer-desc" }
const _hoisted_4 = { class: "stacking-drawer-title" }
const _hoisted_5 = { class: "stacking-drawer-subtitle font-14 PingFangSC-Regular" }

import useDrawer, { OffsetUpdater } from '@/hooks/use-drawer'
import { computed, watch, ref, onUnmounted } from 'vue'
import {
  useCameraFrameStore,
  useConfAndQueryStore,
  useLayoutStore,
  useStackingStore
} from '@/store'
import { storeToRefs } from 'pinia'
import useSelect from '@/hooks/use-select'
import { ClickAction } from '@/data/report'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'StackingPanel',
  props: {
  isLoading: Boolean,
  idle: Boolean
},
  setup(__props) {

const props = __props

const { report } = useConfAndQueryStore()
const cameraFrameStore = useCameraFrameStore()
const { resumeCamera, pauseCamera } = cameraFrameStore
const layoutStore = useLayoutStore()
const { isSnapshotLayerVisible } = storeToRefs(layoutStore)
const { updatePdpExpandingProgress, resetPdpExpandingProgress } = layoutStore
const { hasSelectedStacking } = useSelect()
const stackingStore = useStackingStore()
const scrollview = ref()

const { target, offset, isScrollable, onMaskClick } = useDrawer(
  106,
  toExpand => {
    if (toExpand) report(ClickAction.STACKING_TILE, stackingInfo.value.titleKey)
  }
)

const visibility = computed<
  'loading' | 'snapshotting' | 'idle' | 'ready' | 'visible'
>(() => {
  if (props.isLoading) return 'loading'
  if (isSnapshotLayerVisible.value) return 'snapshotting'
  if (!hasSelectedStacking.value) return 'ready'
  if (props.idle) return 'idle'
  return 'visible'
})

const zIndex = computed(() =>
  offset.value.progress === 0 && offset.value._updater === OffsetUpdater.NONE
    ? 10
    : 30
)

const style = computed(() => {
  return {
    '--scrollview-overflow': isScrollable.value ? 'hidden auto' : 'hidden',
    '--mask-opacity': offset.value.progress / 100,
    '--mask-transition': 'opacity ease 0.6s',
    '--z-index': zIndex.value,
    '--computed-offset-y': `${offset.value.y}px`
  }
})

const stackingInfo = computed(() => {
  return {
    titleKey: stackingStore.selectedStacking?.titleString || '',
    titleFragments: (stackingStore.selectedStacking?.title || []).map(
      ({
        text,
        isAsciiOrExtended
      }: {
        text: string
        isAsciiOrExtended: boolean
      }) => ({
        text,
        typo: isAsciiOrExtended
          ? 'ABChanelCorpo-2022-Regular font-16'
          : 'PingFangSC-Medium font-14'
      })
    ),
    count: stackingStore.selectedStacking?.products?.length,
    products: stackingStore.selectedStacking?.products
  }
})

const isScrollMaskShown = ref(false)
const onScrollviewScroll = () => {
  if (scrollview.value?.scrollTop >= 30) {
    isScrollMaskShown.value = true
  } else {
    isScrollMaskShown.value = false
  }
}

watch(offset, ov => {
  // if (ov._updater === OffsetUpdater.NONE || ov._updater === OffsetUpdater.CSS) {
  //   console.log('[[ Drawer ] Stacking Panel Offset ]', offset.value)
  // }
  updatePdpExpandingProgress({
    target: 'stacking',
    y: ov.y,
    progress: ov.progress / 100,
    transiting: ov._updater !== OffsetUpdater.NONE,
    transitingByCSS: ov._updater === OffsetUpdater.CSS
  })
  if (ov._real_progress === 0 && ov._updater === OffsetUpdater.NONE) {
    resumeCamera()
  } else if (ov._updater !== OffsetUpdater.NONE) {
    pauseCamera()
  }
  if (ov.progress === 0 && ov._updater === OffsetUpdater.NONE) {
    scrollview.value?.scrollTo({
      top: 0
    })
  }
})

onUnmounted(() => {
  // console.log('[[ Layout ] Stacking Panel Unmounted ]')
  resetPdpExpandingProgress()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "stacking-panel-container",
    style: _normalizeStyle(style.value)
  }, [
    _createElementVNode("div", {
      class: "stacking-panel-mask",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onMaskClick) && _unref(onMaskClick)(...args)))
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["stacking-drawer", [visibility.value, _unref(layoutStore).drawerStateClassName]]),
      ref_key: "target",
      ref: target
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(['stacking-drawer-content_inner', visibility.value])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["stacking-drawer-mask", {
                mask: isScrollMaskShown.value
              }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["stacking-drawer-bar", {
                bigger: _unref(offset).progress >= 18
              }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["stacking-drawer-infos", {
                hidden: _unref(offset).progress >= 18
              }])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stackingInfo.value.titleFragments, (fragment, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: index,
                      class: _normalizeClass(fragment.typo)
                    }, _toDisplayString(fragment.text), 3))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_5, _toDisplayString(stackingInfo.value.count) + "款产品 ", 1)
              ])
            ], 2)
          ]),
          _createElementVNode("div", {
            ref_key: "scrollview",
            ref: scrollview,
            class: "stacking-drawer-scrollview",
            "data-is-touchable": "both",
            onScroll: onScrollviewScroll
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 544)
        ], 2)
      ])
    ], 2)
  ], 4))
}
}

})